import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import {
  signInSuccess,
  signFailure,
  authDocumentSuccess,
  forgetPasswordSuccess,
} from './actions';

export function* signIn({ payload }) {
  try {
    const { document, password } = payload;

    const response = yield call(api.post, '/api/v1/WSLogin', {
      documento: document.replace(/\D/g, ''),
      senha: password,
    });

    const { conteudo } = response.data;
    const { token } = response.data.conteudo;
    //window.localStorage.setItem("_token_", btoa(`${token}`))
    
    if (token) {
      yield put(signInSuccess(token, conteudo));
      history.push('/MeusImoveis');
    }
  } catch (error) {
    console.error(error);
    toast.error('Documento e/ou senha incorreto.');
    yield put(signFailure());
  }
}

export function* authDocument({ payload }) {
  try {
    const { document } = payload;

    const response = yield call(api.get, 'api/v1/WSCadastroCliente', {
      params: { documento: document.replace(/\D/g, '') },
    });

    const { mensagem: message, conteudo: content, sucesso: success } = response.data;

    // Se a API retornou sucesso: false explicitamente, você já pode tratar como erro
    if (success === false) {
      toast.error(message || 'Erro ao consultar documento.');
      yield put(signFailure()); // <--- Desliga o loading aqui!
      return; // Interrompe a execução
    }

    if (message.includes('Enviada nova senha para o e-mail')) {
      // ... seu código atual do email
    } else if (
      message.includes(
        'Cliente sem cadastro de e-mail, entrar em contato com o atendimento'
      )
    ) {
      yield put(authDocumentSuccess(message));
      history.push('/NovoCadastro', { reload: true });
    } else if (
      message.includes('Cliente já cadastrado, pode realizar o login.')
    ) {
      localStorage.setItem('name', content.nome);
      localStorage.setItem('document', document);
      yield put(authDocumentSuccess(content));
      history.push('/Login', { reload: true });
    } else {
      // FALLBACK: Se caiu aqui, é uma mensagem não mapeada.
      // Trate como falha para não deixar o loader infinito.
      toast.error(message || 'Retorno inesperado da API.');
      yield put(signFailure());
    }
  } catch (error) {
    toast.error('Não foi localizado o documento informado.');
    yield put(signFailure());
  }
}

export function* forgetPassword({ payload }) {
  try {
    const { document } = payload;

    const response = yield call(api.post, 'api/v1/WSRecuperarSenha', {
      documento: document.replace(/\D/g, ''),
    });

    const { mensagem } = response.data;

    const newPassword = true;

    if (mensagem.includes('Enviada nova senha para o e-mail')) {
      mensagem.replace('Enviada nova senha para o e-mail ', '');
      mensagem.substring(32, mensagem.indexOf('@') + 30);

      const arrayEmail = mensagem.split('@');
      const newEmail = `${arrayEmail[0].slice(33, 36)}...@${arrayEmail[1]}`;

      localStorage.setItem('newPassword', newPassword);
      localStorage.setItem('message', newEmail);
      yield put(forgetPasswordSuccess(mensagem));
      history.push('/NovoRegistro', { reload: true });
    } else {
      toast.error(mensagem);
      yield put(signFailure());
    }
  } catch (err) {
    toast.error('Erro interno, por favor tente novamente mais tarde.');
    console.error(err);
    yield put(signFailure());
  }
}

export function* signUp({ payload }) {
  try {
    const { name, email, password } = payload;

    yield call(api.post, 'users', {
      name,
      email,
      password,
      provider: true,
    });

    history.push('/');
  } catch (err) {
    toast.error('Erro interno, por favor tente novamente mais tarde.');
    yield put(signFailure());
  }
}

export function setToken({ payload }) {
  if (!payload) return;

  const { token } = payload.auth;

  if (token) {
    api.defaults.headers.Authorization = `Bearer ${token}`;
  }
}

export function signOut() {
  history.push('/');
}

export default all([
  takeLatest('persist/REHYDRATE', setToken),
  takeLatest('@auth/SIGN_IN_REQUEST', signIn),
  takeLatest('@auth/SIGN_UP_REQUEST', signUp),
  takeLatest('@auth/SIGN_OUT', signOut),
  takeLatest('@auth/AUTH_DOCUMENT_REQUEST', authDocument),
  takeLatest('@auth/FORGET_PASSWORD_REQUEST', forgetPassword),
]);
